module.exports = __webpack_public_path__ + "img/sixpackcarrier25.884e71bd.jpg";